import React, { useState } from "react";
import {
  CheckCircle,
  Clock,
  User,
  ChevronDown,
  ClipboardList,
} from "lucide-react";
import { usePendencias } from "../context/PendenciasContext";
import { useAuth } from "../../auth/context/AuthContext";
import { podeEscreverClinico } from "../../../shared/utils/permissoesCategoria";
import { theme } from "../../../shared/styles/theme";

export default function ListaPendencias() {
  const { pendencias, concluirPendencia } = usePendencias();
  const { usuarioLogado } = useAuth();
  // 🔐 B88 (AI_98): nome legado - hoje significa "somente leitura".
  // Cobre convidado E observador (espelho de canWriteClinical das rules).
  const isConvidado = !podeEscreverClinico(usuarioLogado);
  const [expandido, setExpandido] = useState(true);

  if (pendencias.length === 0) return null;

  const porPaciente: Record<
    string,
    { nome: string; items: typeof pendencias }
  > = {};
  pendencias.forEach((p) => {
    if (!porPaciente[p.pacienteId]) {
      porPaciente[p.pacienteId] = { nome: p.pacienteNome, items: [] };
    }
    porPaciente[p.pacienteId].items.push(p);
  });

  const formatarData = (iso: string) => {
    if (!iso) return "";
    const d = new Date(iso);
    return `${String(d.getDate()).padStart(2, "0")}/${String(
      d.getMonth() + 1
    ).padStart(2, "0")}/${d.getFullYear()}`;
  };

  const handleConcluir = async (id: string) => {
    if (isConvidado) return;
    if (!window.confirm("Marcar esta pendência como concluída?")) return;
    await concluirPendencia(id);
  };

  return (
    <div style={{ marginTop: "24px" }}>
      <div
        style={{
          background: "#fffbeb",
          border: "1px solid #f59e0b",
          borderLeft: "4px solid #f59e0b",
          borderRadius: theme.borderRadius.lg,
          overflow: "hidden",
        }}
      >
        <button
          onClick={() => setExpandido(!expandido)}
          style={{
            width: "100%",
            padding: "14px 16px",
            background: "transparent",
            border: "none",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <ClipboardList size={18} color="#92400e" />
            <div style={{ textAlign: "left" }}>
              <p
                style={{
                  margin: 0,
                  fontWeight: "700",
                  fontSize: "14px",
                  color: "#92400e",
                  fontFamily: theme.fonts.sans,
                }}
              >
                Pendências do Serviço
              </p>
              <p
                style={{
                  margin: 0,
                  fontSize: "12px",
                  color: "#b45309",
                  fontFamily: theme.fonts.sans,
                }}
              >
                {pendencias.length} pendência(s) em aberto ·{" "}
                {Object.keys(porPaciente).length} paciente(s)
              </p>
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <span
              style={{
                background: "#f59e0b",
                color: "white",
                borderRadius: "999px",
                padding: "3px 10px",
                fontSize: "12px",
                fontWeight: "700",
                fontFamily: theme.fonts.sans,
              }}
            >
              {pendencias.length}
            </span>
            <ChevronDown
              size={16}
              color="#92400e"
              style={{
                transform: expandido ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.2s",
              }}
            />
          </div>
        </button>
        {expandido && (
          <div
            style={{
              borderTop: "1px solid #fde68a",
              padding: "12px 16px",
              display: "flex",
              flexDirection: "column",
              gap: "12px",
            }}
          >
            {Object.entries(porPaciente).map(([pacienteId, grupo]) => (
              <div key={pacienteId}>
                <p
                  style={{
                    margin: "0 0 6px 0",
                    fontWeight: "700",
                    fontSize: "13px",
                    color: "#1e293b",
                    fontFamily: theme.fonts.sans,
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  <User size={13} color="#64748b" />{" "}
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      window.open(
                        `${window.location.origin}/prontuario/${pacienteId}`,
                        "_blank"
                      );
                    }}
                    style={{
                      cursor: "pointer",
                      textDecoration: "underline",
                    }}
                    title="Abrir prontuário em nova aba"
                  >
                    {grupo.nome}
                  </span>
                </p>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "6px",
                    paddingLeft: "20px",
                  }}
                >
                  {grupo.items.map((p) => (
                    <div
                      key={p.id}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "8px 12px",
                        background: "white",
                        borderRadius: theme.borderRadius.md,
                        border: "1px solid #fde68a",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <Clock size={12} color="#b45309" />
                        <div>
                          <p
                            style={{
                              margin: 0,
                              fontSize: "13px",
                              color: "#1e293b",
                              fontFamily: theme.fonts.sans,
                            }}
                          >
                            {p.descricao}
                          </p>
                          <p
                            style={{
                              margin: 0,
                              fontSize: "10px",
                              color: "#94a3b8",
                              fontFamily: theme.fonts.sans,
                            }}
                          >
                            {formatarData(p.criadoEm)} · {p.criadoPorNome}
                          </p>
                        </div>
                      </div>
                      {!isConvidado && (
                        <button
                          onClick={() => handleConcluir(p.id)}
                          title="Marcar como concluído"
                          style={{
                            background: "#dcfce7",
                            color: "#15803d",
                            border: "none",
                            borderRadius: "999px",
                            padding: "4px 10px",
                            fontSize: "11px",
                            fontWeight: "700",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            fontFamily: theme.fonts.sans,
                          }}
                        >
                          <CheckCircle size={12} /> Concluir
                        </button>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
